import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

const CLE = "fodindin_vue_avant_paiement";

/** Pages « contenu » qu'un membre consultait avant de payer : c'est là qu'il veut revenir. */
const EST_VUE_CONTENU = (chemin) =>
  /^\/(categorie\/[^/]+\/annonces|annonces\/[^/]+|annonce\/[^/]+|air-bengue|ville\/[^/]+|love|contacts)/.test(chemin);

/** Mémorise la dernière vue de contenu (hors retour de paiement). */
export const useMemoriserVue = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (search.includes("paye=1") || pathname.startsWith("/paiement")) return;
    if (!EST_VUE_CONTENU(pathname)) return;
    try {
      localStorage.setItem(CLE, pathname + search);
    } catch {
      /* stockage indisponible : la flèche de retour sera simplement absente */
    }
  }, [pathname, search]);
};

export const vueAvantPaiement = () => {
  try {
    return localStorage.getItem(CLE) || null;
  } catch {
    return null;
  }
};

/** Flèche de retour affichée après un paiement : ramène le membre exactement sur
 *  l'annonce ou la liste qui l'avait attiré (FodindinLago, ClubVIP, Air-Bengue, Love). */
export const RetourVuePrecedente = ({ libelle = "Revenir à ce que je consultais", className = "" }) => {
  const { pathname, search } = useLocation();
  const cible = vueAvantPaiement();
  if (!cible || cible === pathname + search || cible === pathname) return null;
  return (
    <Link
      to={cible}
      data-testid="retour-vue-precedente"
      className={`inline-flex items-center gap-2 rounded-full border border-[#E5DFD5] bg-white/95 px-4 py-2 text-sm font-semibold text-stone-700 shadow-sm transition-colors hover:border-stone-900 hover:text-stone-900 ${className}`}
    >
      <ArrowLeft size={15} /> {libelle}
    </Link>
  );
};
